<template>
  <encryption-field :field-name="fieldName" :encrypted-value="value" :label="label">
    <template #default="{ value: revealed }">
      <span v-if="!urls(revealed).length">********</span>
      <a
        v-for="(url, index) in urls(revealed)" :key="url" :href="url"
        target="_blank" rel="noopener noreferrer"
      >{{ label }} {{ index + 1 }}</a>
    </template>
  </encryption-field>
</template>
<script>
import EncryptionField from '@/components/EncryptionField/index.vue';
export default {
  name: 'SensitiveAttachments',
  components: { EncryptionField },
  props: { value: { type: String, default: '' }, fieldName: { type: String, required: true }, label: { type: String, required: true }},
  methods: { urls(value) { return typeof value === 'string' ? value.split(',').filter(url => /^https?:\/\//i.test(url)) : []; } }
};
</script>
